import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
  GET_DASHBOARD_DETAIL,
  INSERT_DASHBOARD,
  UPDATE_DASHBOARD,
  DELETE_DASHBOARD,
} from '../constants/Dashboard';
import { setDashBoardDetail } from '../actions/Dashboard';
import { showAuthMessage } from '../actions/Auth';
import { appIntl } from 'IntlGlobalProvider';

import ApiService from 'services/ApiService';
import utils from 'utils';

export function* callDashboardDetail() {
  yield takeEvery(GET_DASHBOARD_DETAIL, function* ({ payload }) {
    const url = `/dashboard/${payload}`;

    try {
      const list = yield call(ApiService.get, url, {});
      if (list) {
        yield put(setDashBoardDetail(list.data));
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callInsertDashboard() {
  yield takeEvery(INSERT_DASHBOARD, function* ({ payload }) {
    try {
      const url = `/dashboard`;
      const res = yield call(ApiService.post, url, payload);
      console.log('res >>>', res);
      if (res?.statusCode === 201) {
        utils.openNotificationWithIcon(
          'success',
          appIntl().formatMessage({ id: 'message.account.0000009' })
        );
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callUpdateDashboard() {
  yield takeEvery(UPDATE_DASHBOARD, function* ({ payload }) {
    try {
      const { batSeq } = payload;
      const url = `/dashboard/${batSeq}`;
      const res = yield call(ApiService.patch, url, payload);
      console.log('res >>>', res);
      if (res.resultCode === 201) {
        utils.openNotificationWithIcon(
          'success',
          appIntl().formatMessage({ id: 'message.account.0000009' })
        );
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callDeleteDashboard() {
  yield takeEvery(DELETE_DASHBOARD, function* ({ payload }) {
    try {
      const { batSeq } = payload;
      const url = '/dashboard/' + batSeq;
      const params = {};
      const res = yield call(ApiService.delete, url, params);
      if (res.resultCode === 201) {
        utils.openNotificationWithIcon(
          'success',
          appIntl().formatMessage({ id: 'message.account.0000013' })
        );
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(callDashboardDetail),
    fork(callInsertDashboard),
    fork(callUpdateDashboard),
    fork(callDeleteDashboard),
  ]);
}
